export const audios = {
  intro: "/audios/intro.mp3",
  stages_complete: "/audios/stages-complete.mp3",
} as const;
